module.exports = __webpack_public_path__ + "static/media/salao_atico_6.6d47483a.jpg";